<template>
  <div v-if="type === 'cloudflare'" class="integration-menu">
    <div class="integration-menu__header">
      <div class="integration-menu__title">{{title}}</div>
    </div>
    <input
      class="integration-menu__input"
      placeholder="Email"
      borderless
      v-model="cloudflare_email"
    />
    <input
      class="integration-menu__input"
      placeholder="Account ID"
      borderless
      v-model="cloudflare_account_id"
    />
    <input
      class="integration-menu__input"
      placeholder="API Key"
      borderless
      v-model="cloudflare_api_key"
    />
    <div class="integration-menu__footer">
      <button v-if="isChangeMode && isDataLoaded"
              class="integration-menu__button integration-menu__button_delete"
              :class="{'integration-menu__button_disabled': disableButtons}"
              @click="removeIntegration">delete integration</button>
      <button class="integration-menu__button integration-menu__button_cancel"
              :class="{'integration-menu__button_disabled': disableButtons}"
              @click="close(false)">cancel</button>
      <button v-if="isDataLoaded"
              class="integration-menu__button integration-menu__button_add"
              :class="{'integration-menu__button_disabled': disableButtons}"
              @click="apply">apply</button>
    </div>
  </div>
  <div v-else-if="type === 'shopify'" class="integration-menu">
    <div class="integration-menu__header">
      <div class="integration-menu__title">{{title}}</div>
    </div>
    <input
      class="integration-menu__input"
      placeholder="Access Token"
      borderless
      v-model="shopify_access_token"
    />
    <div class="integration-menu__footer">
      <button v-if="isChangeMode && isDataLoaded"
              class="integration-menu__button integration-menu__button_delete"
              :class="{'integration-menu__button_disabled': disableButtons}"
              @click="removeIntegration">delete integration</button>
      <button class="integration-menu__button integration-menu__button_cancel"
              :class="{'integration-menu__button_disabled': disableButtons}"
              @click="close(false)">cancel</button>
      <button v-if="isDataLoaded"
              class="integration-menu__button integration-menu__button_add"
              :class="{'integration-menu__button_disabled': disableButtons}"
              @click="apply">apply</button>
    </div>
  </div>
  <div v-else class="integration-menu">
    <div class="integration-menu__header">
      <div class="integration-menu__title">{{title}}</div>
    </div>
    <div v-if="isServiceNotConnected" class="integration-menu__connect_to_asana">
        <a class="integration-menu__user_text integration-menu__user_link"
           @click="connectService"
           :class="{'integration-menu__button_disabled': disableButtons}"
           :href="changeAccountLink">{{serviceConnectionTitle}}</a>
    </div>
    <div v-else-if="isDataLoaded " class="integration-menu__body">
      <div v-if="isChangeMode" class="integration-menu__user">
        <div class="integration-menu__account">
          <base-material-design-icon class="integration-menu__account_icon" icon="account"/>
          <span class="integration-menu__user_text">{{userName}}</span>
        </div>
        <a class="integration-menu__user_text integration-menu__reauth integration-menu__user_link"
           @click="disableButtons = true"
           :class="{'integration-menu__button_disabled': disableButtons}"
           :href="changeAccountLink">Reauthorize</a>
      </div>
      <div class="integration-menu__workspace-selection">
        <div class="integration-menu__workspace-selection_block">
          <div class="integration-menu__workspace-selection_label">Workspace</div>
          <base-select class="integration-menu__select"
                       :class="{'integration-menu__select_err': selectErrors.includes('workspace')}"
                       :options="workspaceOptions"
                       alignLeft
                       :isSmartInput="true"
                       :isSortAsc="true"
                       :disabled="disableButtons"
                       showTopBorder
                       shiftLabelRight
                       v-model="workspace"
                       :selectStyle="{height: '60px!important'}"
                       placeholder="Select workspace"/>
        </div>
        <div class="integration-menu__workspace-selection_block">
          <div class="integration-menu__workspace-selection_label">Projects</div>
          <base-select class="integration-menu__select"
                       :class="{'integration-menu__select_err': selectErrors.includes('project')}"
                       :options="projectOptions"
                       alignLeft
                       :isSmartInput="true"
                       :isSortAsc="true"
                       :disabled="!projectOptions.length || disableButtons"
                       showTopBorder
                       shiftLabelRight
                       v-model="project"
                       :selectStyle="{height: '60px!important'}"
                       placeholder="Select project"/>
        </div>
      </div>
    </div>
    <div v-else class="integration-menu__no-data">
      Awaiting Data
    </div>
    <div class="integration-menu__footer">
      <button v-if="isChangeMode && isDataLoaded"
              class="integration-menu__button integration-menu__button_delete"
              :class="{'integration-menu__button_disabled': disableButtons}"
              @click="removeIntegration">delete integration</button>
      <button class="integration-menu__button integration-menu__button_cancel"
              :class="{'integration-menu__button_disabled': disableButtons}"
              @click="close(false)">cancel</button>
      <button v-if="isDataLoaded"
              class="integration-menu__button integration-menu__button_add"
              :class="{'integration-menu__button_disabled': disableButtons}"
              @click="apply">apply</button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import BaseModalMixins from '@/common/BaseModalMixins'

export default {
  name: 'BaseIntegrationMenu',
  mixins: [BaseModalMixins],
  mounted () {
    !this.isServiceNotConnected && this.loadData()
  },
  props: {
    type: {
      type: String,
      require: true
    },
    currentClientId: {
      type: String,
      require: true
    },
    selectedIntegrations: {
      type: Array,
      require: true
    },
    // integrate - for content brief
    // change - for integration manage
    // update - when service just integrated to save default fields
    mode: {
      type: String,
      require: true
    },
    integrationMode: {
      type: String,
      require: true
    },
    integrationLinks: {
      type: Object,
      require: true
    },
    changeAccountLink: {
      type: String,
      default: '#'
    },
    // integratedServices: {
    //   type: Array,
    //   default: () => []
    // },
    connectedServices: {
      type: Array,
      default: () => []
    },
    isSaveAsDefaults: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selectedService: null,
      isDataLoaded: false,
      workspace: '',
      project: '',
      clientIdCopy: null,
      disableButtons: false,
      selectErrors: [],
      cloudflare_email: '',
      cloudflare_api_key: '',
      cloudflare_account_id: '',
      cloudflare_enabled: '',
      shopify_access_token: ''
    }
  },
  watch: {
    workspace () {
      if (this.isDataLoaded) {
        this.project = null
      }
    }
  },
  computed: {
    ...mapState('integrations', {
      isError (state) {
        return !Object.keys(state.integrationData).length && this.isDataLoaded
      },
      userName (state) {
        if (!state.integrationData.user_name && this.isError) {
          // used switch for next integrations
          switch (this.type) {
            case 'asana':
              return 'Can\'t connect to Asana'
          }
        }
        return state.integrationData.user_name
      },
      workspaceOptions (state) {
        if (!Object.keys(state.integrationData).length || !state.integrationData.workspaces.length) {
          return []
        }
        return state.integrationData.workspaces.map(i => ({ label: i.label, value: i.id }))
      },
      projectOptions (state) {
        if (!Object.keys(state.integrationData).length || !state.integrationData.workspaces.length) {
          return []
        }
        const selectedWorkspace = state.integrationData.workspaces.find(i => i.id === this.workspace)
        if (!selectedWorkspace) return []
        return selectedWorkspace.projects.map(i => ({ label: i.label, value: i.id }))
      }
    }),
    isChangeMode () {
      return this.mode === 'change'
    },
    // isServiceIntegrated (state) {
    //   return this.integratedServices.find(i => i.name === this.type)
    // },
    isServiceNotConnected () {
      return (this.mode === 'integrate' && !this.connectedServices.includes(this.type) && !this.isSaveAsDefaults) ||
        (this.mode === 'integrate' && this.isError && !this.isSaveAsDefaults)
    },
    title () {
      const changeTitles = {
        'asana': 'Edit Asana Integration'
      }
      const integrationTitles = {
        'asana': 'Asana Integration'
      }
      if (this.type === 'cloudflare') {
        return 'Cloudflare Integration'
      } else if (this.type === 'shopify') {
        return 'Shopify Integration'
      }
      return this.isChangeMode ? changeTitles[this.type] : integrationTitles[this.type]
    },
    serviceConnectionTitle () {
      const serviceConnectionTitles = {
        'asana': 'Connect To Asana'
      }
      return serviceConnectionTitles[this.type]
    }
  },
  methods: {
    ...mapActions('integrations', ['getIntegrationData', 'deleteIntegration', 'changeIntegration', 'multipleIntegrationAction']),
    async loadData () {
      this.clientIdCopy = this.currentClientId
      this.isDataLoaded = false
      const response = await this.getIntegrationData({
        clientId: this.clientIdCopy,
        integrationName: this.type
      })
      if (response && Object.keys(response).length) {
        this.workspace = response.default_workspace
        this.project = response.default_project
        this.cloudflare_email = response.cloudflare_email
        this.cloudflare_api_key = response.cloudflare_api_key
        this.cloudflare_account_id = response.cloudflare_account_id
        this.cloudflare_enabled = response.cloudflare_enabled
        this.shopify_access_token = response.shopify_access_token
      }
      // it stops workspace value watcher to set the 'project' to null on first data load
      this.$nextTick(() => {
        this.isDataLoaded = true
      })
    },
    close (update = true) {
      this.$emit('close', update)
    },
    async removeIntegration () {
      this.disableButtons = true
      await this.deleteIntegration({
        clientId: this.clientIdCopy,
        integrationName: this.type
      })
      this.close()
    },
    connectService () {
      this.disableButtons = true
      if (this.$route.name === 'url-planner') {
        const selectedIntegrations = JSON.stringify(this.selectedIntegrations)
        try {
          localStorage.setItem('selectedIntegrations', selectedIntegrations)
        } catch (e) {
          console.log(e)
        }
      }
    },
    async apply () {
      const selectErrors = []
      if (this.type !== 'cloudflare' && this.type !== 'shopify') {
        !this.workspace && selectErrors.push('workspace')
        !this.project && selectErrors.push('project')
      }
      if (selectErrors.length) {
        this.selectErrors = selectErrors
        return
      }
      this.$emit('sendingData')
      this.disableButtons = true
      if (this.mode === 'integrate') {
        const [ integrationName, integrationAction ] = this.integrationMode.toLowerCase().split('_')
        // const successMessage = `Tasks ${integrationAction === 'add' ? 'added' : integrationAction + 'd'} successfully`
        const successMessage = `Task${this.selectedIntegrations.length > 1 ? 's' : ''} added successfully`
        const infoMessage = `Content Brief${this.selectedIntegrations.length > 1 ? 's have' : ' has'} already been integrated`
        try {
          const params = {
            clientId: this.clientIdCopy,
            integration_name: integrationName,
            selected_content_briefs: this.selectedIntegrations.join(','),
            integration_action: integrationAction,
            successMessage,
            infoMessage,
            workspace: this.workspace,
            project: this.project,
            isSaveAsDefaults: this.isSaveAsDefaults
          }
          await this.multipleIntegrationAction(params)
          // this.integrationMode = null
        } catch (e) {
        }
      } else {
        await this.changeIntegration({
          clientId: this.clientIdCopy,
          integrationName: this.type,
          workspace: this.workspace,
          project: this.project,
          cloudflare_email: this.cloudflare_email,
          cloudflare_api_key: this.cloudflare_api_key,
          cloudflare_account_id: this.cloudflare_account_id,
          cloudflare_enabled: this.cloudflare_enabled,
          shopify_access_token: this.shopify_access_token
        })
      }
      this.close()
    }
  }
}
</script>

<style scoped lang="scss">
  .integration-menu {
    background-color: #fff;
    padding: 40px;
    border-radius: 15px;

    &__input {

      display: flex;
      flex-direction: column;
      position: relative;
      margin-top: 25px;
      // margin-left: 10px;
      // border: 0;
      background-color: #fff;
      border: 1px solid $rfx-light-steel;
      padding: 20px;
      border-radius: 4px;
      outline: none;

        width: 100%;
        box-sizing: border-box;
        padding-right: 60px;
        font-weight: 500;
        @include ellipsis;
    }
    &__connect_to_asana {
      text-align: center;

      a {
        font-size: 18px;
        color: white;
        background-color: $rfx-dark-march;
        border-radius: 8px;
        padding: 10px 25px;

        &:visited {
          color: white;
        }
      }
    }

    &__select {
      &_err {
        border: 1px solid $rfx-light-red;
      }
    }

    &__title {
      margin: 0 auto;
      padding-bottom: 40px;
      text-align: center;
      font-size: 24px;
      line-height: 32px;
      color: $rfx-dark-march;
      font-weight: bold;
    }

    &__account {
      display: flex;
      align-items: center;

      &_icon {
        font-size: 24px;
      }
    }

    &__button {
      min-width: 100px;
      padding: 0 25px;
      height: 40px;
      font-size: 10px;
      font-weight: 900;
      cursor: pointer;
      text-transform: uppercase;
      border-radius: 8px;
      outline: none;
      border: none;

      &_cancel {
        color: $rfx-dark-march;
        margin-left: auto;
        margin-right: 30px;
      }

      &_add {
        color: #fff;
        background-color: $rfx-dark-march;
      }

      &_delete {
        color: #fff;
        background-color: $rfx-red;
      }

      &_disabled {
        pointer-events: none;
        opacity: .5;
      }
    }

    &__reauth {
      color: $rfx-red !important;
      margin-left: auto;
    }

    &__user {
      display: flex;
      align-items: center;
      /*justify-content: space-between;*/
      justify-content: flex-start;
      margin-bottom: 40px;
      font-size: 15px;
      font-weight: 500;

      &_text {
        text-decoration: none;
        color: $rfx-dark-march;
      }

      &_link {
        text-transform: uppercase;
        font-size: 10px;
        font-weight: 900;

        &:visited {
          color: $rfx-dark-march;
        }
      }
    }

    &__footer {
      margin-top: 40px;
      display: flex;
      align-items: center;
    }

    &__workspace-selection {
      display: flex;

      &_block {
        flex: 1;

        &:first-child {
          padding-right: 15px;
        }

        &:last-child {
          padding-left: 15px;
        }
      }

      &_label {
        font-size: 14px;
        margin-bottom: 8px;
        color: $rfx-dark-march;
      }
    }

    &__no-data {
      font-size: 24px;
      font-weight: 600;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      color: $rfx-light-march;
      padding: 30px 0;
    }
  }
</style>
